import { Component, OnInit, HostListener } from '@angular/core';

@Component({
  selector: 'app-go-top1',
  templateUrl: './go-top1.component.html',
  styleUrls: ['./go-top1.component.scss']
})
export class GoTop1Component implements OnInit {

  constructor() { }

  isShow: boolean;
  topPosToStartShowing = 100;

  @HostListener('window:scroll')
  checkScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    // console.log('[scroll]', scrollPosition);
    
    if (scrollPosition >= this.topPosToStartShowing) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  }

  // TODO: Cross browsing
  gotoTop() {
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }
  ngOnInit(): void {
  }

}
